/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "D:/WebstormProjects/hardware/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Confirm from 'vux/src/components/confirm';
import XButton from 'vux/src/components/x-button';
import TransferDom from 'vux/src/directives/transfer-dom';
export default {
  name: 'My',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    XButton: XButton,
    Confirm: Confirm
  },
  data: function data() {
    return {
      showdangantouxiang: require('@/assets/photo_man.png'),
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.scrollY || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      },
      navData: [],
      //导航数组
      showToast: false,
      userName: this.$utils.Store.getItem('userLname'),
      userNo: this.$utils.Tools.isnull(this.$utils.Store.getItem('spareCol1'), this.$utils.Store.getItem('userNo')),
      userTelephone: this.$utils.Store.getItem('userTelephone') + '',
      userPassword: '',
      pushValue: +this.$utils.Store.getLocalItem('pushValue'),
      //是否推送消息，
      pushValue_num: '',
      headImage: this.$utils.Store.getLocalItem('headImage') || require('@/assets/photo_man.png'),
      //默认头像
      cardState: -1,
      //卡片状态  0 未发卡；1 已发卡；2 已挂失
      list: [{
        msrc: this.$utils.Store.getLocalItem('headImage') || require('@/assets/photo_man.png'),
        src: this.$utils.Store.getLocalItem('headImage') || require('@/assets/photo_man.png')
      }]
    };
  },
  computed: {
    isHavePhone: function isHavePhone() {
      return this.userTelephone && this.userTelephone !== '' && this.userTelephone != 'null';
    }
  },
  methods: {
    // 获取发卡状态
    getCardState: function getCardState() {
      //卡片状态  0 未发卡；1 已发卡；2 已挂失
      var state = '';

      switch (this.cardState) {
        case 0:
          state = '未发卡';
          break;

        case 1:
          state = '已发卡';
          break;

        case 2:
          state = '已挂失';
          break;
      }

      return state;
    },
    // 获取是否显示link图标
    getShowRowLink: function getShowRowLink(row) {
      return !(row.menuId === '990403000000' || row.menuId === '990404000000');
    },
    // 获取档案照片呢
    getuserphoto: function getuserphoto() {
      var _this = this;

      this.$api.User.getUser(this.$utils.Store.getItem('userSerial')).then(function (response) {
        _this.$utils.Tools.loadHide();

        _this.$utils.Store.set('serverId', null);

        var data = response.data;
        _this.userInfo = data;

        var aa = require('@/assets/photo_man.png');

        _this.showdangantouxiang = data.userPhotoImg ? data.userPhotoImg : aa;
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    FileDetail: function FileDetail(personid) {
      this.$router.push({
        path: '/FileDetail',
        query: {
          personid: personid
        }
      });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    getWxHeadImage: function getWxHeadImage() {
      var _this2 = this;

      this.$api.My.getWxHeadImage(this.$utils.Store.getItem('userSerial')).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          if (data !== null && data.headImage !== '' && data.headImage !== null) {
            _this2.headImage = data.headImage;

            _this2.$utils.Store.setLocalItem('headImage', data.headImage);
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    getUserHeadImage: function getUserHeadImage() {
      var _this3 = this;

      this.$api.My.getUserHeadImage(this.$utils.Store.getItem('userSerial')).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this3.$code.success) {
          _this3.$utils.Tools.toastShow(msg);
        } else {
          if (data !== null) {
            _this3.list = [];
            _this3.headImage = data;

            _this3.list.push({
              msrc: data,
              src: data
            });

            _this3.$utils.Store.setLocalItem('headImage', data);
          } else {
            _this3.$utils.Store.removeLocalItem('headImage');
          }
        }
      }).catch(function () {
        _this3.$utils.Tools.httpError();
      });
    },
    chooseImage: function chooseImage() {
      var _this4 = this;

      this.$utils.Tools.getEnv(function (res) {
        if (res === 0 || res === 1) {
          _this4.wxChooseImage();
        } else {
          _this4.dtChooseImage();
        }
      });
    },
    dtChooseImage: function dtChooseImage() {
      var _this5 = this;

      this.$utils.DingTalk.uploadImage(function (res) {
        if (_this5.$utils.Tools.isArray(res)) {
          _this5.$api.My.setWxHeadImage({
            mediaId: res.join(','),
            userSerial: _this5.$utils.Store.getItem('userSerial')
          }).then(function (ress) {
            _this5.headImage = ress.data;

            _this5.$utils.Store.setLocalItem('headImage', ress.data); // let i=1;
            // if (i < res.length) {
            //   this.uploadImage(res, i)
            // }

          }).catch();
        }
      }, 1);
    },
    wxChooseImage: function wxChooseImage() {
      var _this6 = this;

      var i = 0;
      this.$utils.WeiXin.wxChooseImage(function (res) {
        if (res.length > 0) {
          _this6.uploadImage(res, i);
        }
      }, 1);
    },
    uploadImage: function uploadImage(res, i) {
      var _this7 = this;

      this.$utils.WeiXin.wxUploadImage(function (serverId) {
        _this7.$api.My.setWxHeadImage({
          mediaId: serverId,
          userSerial: _this7.$utils.Store.getItem('userSerial')
        }).then(function (ress) {
          _this7.headImage = ress.data;

          _this7.$utils.Store.setLocalItem('headImage', ress.data);

          i++;

          if (i < res.length) {
            _this7.uploadImage(res, i);
          }
        }).catch();
      }, res[i]);
    },
    wxInitConfig: function wxInitConfig() {
      var _this8 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.Sys.getConfig(localUrl, this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this8.$code.success) {
          _this8.$utils.Tools.toastShow(msg);
        } else {
          _this8.$utils.WeiXin.wxConfig(data);
        }
      }).catch(function () {
        _this8.$utils.Tools.httpError();
      });
    },
    dtInitConfig: function dtInitConfig() {
      var _this9 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.DingTalk.getDtConfig(localUrl).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          _this9.$utils.Tools.toastShow(msg);
        } else {
          _this9.$utils.DingTalk.getConfig(data);
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    },
    getHomeMenu: function getHomeMenu() {
      var _this10 = this;

      this.$utils.Tools.loadShow();
      this.$api.Home.getHomeMenu({
        companyId: 0,
        userId: this.$utils.Store.getItem('userSerial'),
        spareCol2: 2
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this10.$code.success) {
          _this10.$utils.Tools.loadHide();

          _this10.$utils.Tools.toastShow(msg);
        } else {
          _this10.navData = data;

          _this10.$utils.Store.setLocalItem('menuMy', JSON.stringify(data));

          _this10.$utils.Tools.loadHide();
        }
      }).catch(function () {
        _this10.$utils.Tools.httpError();
      });
    },
    onHide: function onHide() {// document.body && (document.body.scrollTop = document.body.scrollTop)
    },
    navClick: function navClick(value, index, state, menuId) {
      if (value === '990404000000') {
        return;
      }

      if (menuId == '990403000000' && (state == 0 || state == 2)) {
        this.$utils.Tools.toastShow('请联系管理员发卡或解挂');
      } else {
        this.$router.push(value);
      }
    },
    unbind: function unbind() {
      this.showToast = true;
    },
    getPushState: function getPushState() {
      var _this11 = this;

      this.$utils.Tools.loadShow();
      this.$api.My.selectSendState({
        userSerial: this.$utils.Store.getItem('userSerial')
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        _this11.$utils.Tools.loadHide();

        if (+code !== _this11.$code.success) {
          _this11.$utils.Tools.toastShow(msg);
        } else {
          if (data.sendStatus == 0) {
            _this11.pushValue = true;
          } else {
            _this11.pushValue = false;
          }
        }
      }).catch(function () {});
    },
    pushClick: function pushClick() {
      var _this12 = this;

      if (this.pushValue == true) {
        this.pushValue_num = 0;
      } else if (this.pushValue == false) {
        this.pushValue_num = 1;
      }

      this.$utils.Tools.loadShow();
      this.$api.My.pushMessage({
        userSerial: this.$utils.Store.getItem('userSerial'),
        sendStatus: this.pushValue_num
      }).then(function (response) {
        _this12.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this12.$code.success) {
          _this12.$utils.Tools.toastShow(msg);
        } else {
          _this12.$utils.Store.setLocalItem('pushValue', _this12.pushValue);
        }
      }).catch(function () {});
    },
    logout: function logout() {
      var _this13 = this;

      var openId = this.$utils.Store.getItem('openId');
      this.$utils.Store.clear();
      this.$utils.Store.setItem('openId', openId);
      this.$utils.Tools.getEnv(function (res) {
        if (res === 0) {
          _this13.$wechat.miniProgram.navigateBack({
            delta: 1
          });
        } else {
          _this13.$router.replace('/Login');
        }
      });
    },
    deleteInfo: function deleteInfo() {
      var _this14 = this;

      this.$api.My.deleteInfo(this.$utils.Store.getItem('openId')).then(function (response) {
        _this14.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this14.$code.success) {
          _this14.$utils.Tools.toastShow(msg);
        } else {
          _this14.logout();
        }

        return 1;
      }).catch(function () {});
    },
    onConfirm: function onConfirm(value) {
      var _this15 = this;

      this.$utils.Tools.loadShow(); //  this.$utils.Store.localStorage.clear();

      this.$refs.confirm.setInputValue('');
      this.userPassword = value;
      this.$api.My.loginOut({
        openId: this.$utils.Store.getItem('openId'),
        userPassword: value,
        userSerial: this.$utils.Store.getItem('userSerial')
      }).then(function (response) {
        _this15.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this15.$code.success) {
          if (+code === 610) {
            if (_this15.$params.mode === '1') {
              _this15.$utils.Store.removeItem('headImage');

              _this15.deleteInfo();
            } else {
              _this15.$utils.Store.removeItem('headImage');

              _this15.logout();
            }
          } else {
            _this15.$utils.Tools.toastShow(msg);
          }
        } else {
          _this15.$utils.Store.removeItem('headImage');

          if (_this15.$params.mode === '1') {
            _this15.deleteInfo();
          } else {
            _this15.logout();
          }
        }

        return 1;
      }).catch(function () {});
    }
  },
  created: function created() {
    var _this16 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this16.navData = JSON.parse(_this16.$utils.Store.getLocalItem('menuMy'));

              _this16.getuserphoto();

              if (_this16.$params.mytheme === '0') {
                _this16.getWxHeadImage();
              } else {
                _this16.getUserHeadImage();
              }

              _this16.$utils.Tools.getEnv(function (res) {
                if (res === 0 || res === 1) {
                  _this16.wxInitConfig();
                } else {
                  _this16.dtInitConfig();
                }
              });

              _context.next = 6;
              return _this16.$api.My.getCardInfo({
                userSerial: _this16.$utils.Store.getItem('userSerial')
              }).then(function (response) {
                var code = response.code,
                    msg = response.msg,
                    data = response.data;

                if (+code !== _this16.$code.success) {
                  _this16.$utils.Tools.toastShow(msg);
                } else {
                  _this16.cardState = data.userLx;
                }
              }).catch(function () {});

            case 6:
              _this16.getHomeMenu();

              _this16.getPushState();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};